import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from 'store/reducers';
import rootSaga from 'store/sagas';

export const history = createBrowserHistory()

const enhancers = [];
if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__; // 이 부분 확인해봐야 함. 버전에 따라 방식이 변경된 것 같음 
    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}


const sagaMiddleware = createSagaMiddleware();
const composedEnhancers = compose(
    applyMiddleware(
        sagaMiddleware, 
        routerMiddleware(history)
    ), 
    ...enhancers
)
const store = createStore(
    createRootReducer(history),
    composedEnhancers
);

sagaMiddleware.run(rootSaga);

export default store;